// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"f9fb41c4","228":"b4eb2de5","366":"a6c9ebf9","591":"4474c978","755":"e5d3feca"}[chunkId] + ".chunk.js";
};